import { Check } from 'lucide-react'
import { cn } from '@/lib/utils'

interface Props {
  labels: string[]
  currentIndex: number
}

const OnboardingStepper = ({ labels, currentIndex }: Props) => {
  return (
    <ol className='flex w-full items-center sm:pb-6'>
      {labels.map((label, index) => {
        const isCompleted = index < currentIndex
        const isCurrent = index === currentIndex
        const isLast = index === labels.length - 1

        return (
          <li
            key={label}
            className={cn('flex items-center', isLast ? '' : 'flex-1')}
          >
            <span
              className={cn(
                'relative flex h-8 w-8 shrink-0 items-center justify-center rounded-full border text-sm font-medium transition-colors',
                isCompleted &&
                  'border-primary bg-primary text-primary-foreground',
                isCurrent && 'border-primary text-primary',
                !isCompleted &&
                  !isCurrent &&
                  'border-border text-muted-foreground',
              )}
            >
              {isCompleted ? (
                <Check className='h-4 w-4' />
              ) : (
                <span>{index + 1}</span>
              )}
              <span
                className={cn(
                  'absolute left-1/2 top-full mt-1.5 -translate-x-1/2 whitespace-nowrap text-xs transition-colors max-sm:hidden',
                  isCurrent
                    ? 'font-medium text-foreground'
                    : 'text-muted-foreground',
                )}
              >
                {label}
              </span>
            </span>

            {isLast ? null : (
              <span
                className={cn(
                  'mx-2 h-px flex-1 transition-colors',
                  isCompleted ? 'bg-primary' : 'bg-border',
                )}
              />
            )}
          </li>
        )
      })}
    </ol>
  )
}

export default OnboardingStepper
